import { render, staticRenderFns } from "./modalPlugin.vue?vue&type=template&id=58b076c4&"
import script from "./modalPlugin.vue?vue&type=script&lang=js&"
export * from "./modalPlugin.vue?vue&type=script&lang=js&"
import style0 from "./modalPlugin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "modalPlugin.vue"
export default component.exports